import { OverlayController } from '@client/core/modules/Overlays/Overlays';
import { Colors } from '@client/style/Variables';
import React, { useCallback, useRef } from 'react';
import { ImperativeLoginPromptFrame, LoginPromptOverlayFrame } from '@client/modules/shared/LoginPromptOverlayFrame';
import { RegistrationForm } from './RegistrationForm';

interface IProps {
	controller: OverlayController;
}

export const OverlayRegisterPrompt = (props: IProps) => {
	const frame = useRef<ImperativeLoginPromptFrame | null>(null);

	const closeOverlay = useCallback(() => {
		window.setTimeout(() => {
			if (frame.current) {
				frame.current.close(props.controller.close);
			} else {
				props.controller.close();
			}
		}, 1000);
	}, [frame.current]);

	return (
		<LoginPromptOverlayFrame
			ref={frame}
			backgroundColor={Colors.defaultLightGrey}
			dimColor={Colors.defaultOverlayDim}
			onCloseButtonClick={props.controller.close}
		>
			<RegistrationForm onSuccess={closeOverlay} />
		</LoginPromptOverlayFrame>
	);
};
